import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { DEV_AUTH_BYPASS } from './devAuth';

function required(name: string): string {
  const value = import.meta.env[name as keyof ImportMetaEnv] as string | undefined;
  if (!value) throw new Error(`Missing required environment variable ${name}`);
  return value;
}

/** Safari/iOS ITP evicts localStorage in some contexts; mirror the Platform app's fix. */
function isSafari(): boolean {
  const ua = navigator.userAgent;
  return /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
}

export const loginScopes = ['openid', 'profile', 'offline_access'];

/** The API scope the axios interceptor asks for. Never `/common` — this is a staff-only,
 *  single-tenant app, so the authority is the Aiqbee tenant explicitly. */
export const apiScopes = DEV_AUTH_BYPASS ? [] : [required('VITE_ENTRA_SCOPES')];

export const msalConfig: Configuration = DEV_AUTH_BYPASS
  ? ({ auth: { clientId: 'dev-bypass' } } as Configuration)
  : {
      auth: {
        clientId: required('VITE_ENTRA_CLIENT_ID'),
        authority: required('VITE_ENTRA_AUTHORITY'),
        redirectUri: required('VITE_ENTRA_REDIRECT_URI'),
        navigateToLoginRequestUrl: true,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isSafari(),
      },
      system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
            if (containsPii) return;
            if (level === LogLevel.Error) console.error('[msal]', message);
            else if (level === LogLevel.Warning) console.warn('[msal]', message);
          },
          logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
        },
      },
    };

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: [...loginScopes, ...apiScopes],
  prompt: 'select_account' as const,
};
